import React from "react";
import { Link } from "react-router-dom";
import { Anchor, Popover } from "discover.medical.react-component-library";
import { TooltipWrapper } from "./_styled";

export default function glossaryTooltipProcessor({ glossary }) {
  const processGlossaryTooltip = (node, processContentPage) => {
    const triggerText = node.attribs["data-value"];
    const referenceId = node.attribs["data-reference-id"];
    const content = glossary?.[referenceId];

    if (!content) {
      // We were given a referenceId that doesn't exist, let's log it
      window?.DD_RUM?.addError(
        new Error(
          `Glossary content was given a referenceId that does not exist, referenceId: ${referenceId}`
        ),
        {
          scope: "platform-content",
          team: "cd.mergeconflict",
        }
      );
    }

    return (
      <Popover
        placement="top"
        trigger={
          <Anchor
            linkComponent={Link}
            onClick={(e) => e.preventDefault()}
            data-testid="glossary-tooltip"
          >
            {triggerText}
          </Anchor>
        }
        popperComponentProps={{
          variant: "primary",
        }}
      >
        <TooltipWrapper
          preProcessors={[processContentPage()]}
          children={content}
        />
      </Popover>
    );
  };

  return { processGlossaryTooltip };
}
